import { render, staticRenderFns } from "./hard_bounces.vue?vue&type=template&id=3b596e43"
import script from "./hard_bounces.vue?vue&type=script&lang=js"
export * from "./hard_bounces.vue?vue&type=script&lang=js"
import style0 from "./hard_bounces.vue?vue&type=style&index=0&id=3b596e43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports